import { CreateUrl, CallGetAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import {Button } from '@mui/material'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl';
import ClipLoader from "react-spinners/ClipLoader";
interface SimData {
    volume: number, totalVolume: number
}

interface SimStatus {
    loggerId: number
    loggerStatus: string
}


interface Props {
    simData: SimData 
    loggerId: number
}
const SimUsageBar: React.FC<Props> = ({simData, loggerId }) => {

    const [gettingData, setGettingData] = useState<boolean>(false)
    const [simStatus, setSimStatus] = useState<string>("")
    const percentage = (simData.totalVolume - simData.volume) / simData.totalVolume * 100
    const container = {
        width: "60%",
        border: "1px solid black",
        height: "20px",
        marginTop: "2px",
        position: "relative"

    }


    let barColor = '#00BF00'
    let textColor = 'black'
    if (percentage > 60) {
        barColor = 'orange'
    }
    if (percentage > 90) {
        barColor = 'red'
        textColor = 'white'
    }
    const bar = {
        width: `${percentage}%`,
        backgroundColor: barColor,
        height: "18px",

    }
    const handleNetworkCheck = (): void => {
        setGettingData(true)
        CallGetAPI(CreateUrl(`/api/simcard/simstatus?id=${loggerId}`), {})
            .then((data: SimStatus) => {
                setGettingData(false)
                console.log(data)
                setSimStatus(data.loggerStatus)
            })
            .catch(err => {
                console.error(err)
            })
    }
    
    return(
        <div style={{ width: "100%", marginBottom: "15px" }}>
            <h5 style={{ textAlign: "center" }}><b><FormattedMessage id="Sim Data Usage" /></b></h5>
            <div style={{display: "flex", justifyContent: "center"} }>
                <div style={container}>
                <div style={bar }></div>
                    <div style={{ fontSize: "11px", color: textColor, position: "absolute", top: "2px", left: "25%" }}>{`${(simData.totalVolume - simData.volume).toFixed(1)}MB / ${simData.totalVolume}MB - ${percentage.toFixed(0)}%`}</div>
                </div>  
                
            </div>
            <div style={{ display: "flex", width: "100%", justifyContent: "center", marginTop: "8px" }}>
                <div>
                    {!gettingData && !simStatus && <Button variant="contained" onClick={() => { handleNetworkCheck() }}><FormattedMessage id="Check Network Connection" /></Button>}
                    {!gettingData && simStatus && <h4><FormattedMessage id="Sim card status" />: <b>{simStatus.toLowerCase()}</b></h4>}
                </div>
                {gettingData && <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <ClipLoader />
                    </div>
                    <h5><FormattedMessage id="Retrieving Data from Sim Provider" /></h5>
                   
                </div>}
            </div>


            </div>)
}

export default SimUsageBar